import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _single, _WorkActivityGroupUser } from "../../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../../theme/Component/usePaginator";
import { useEffect } from "react";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../editor/AccountEditor";
import { FileService } from "../../../../core/services/FileService";

type WorkgroupActivity = {
    IDWorkActivityGroup: number;
    [key: string]: any;
}

interface Props {
    WorkActivityGroup: WorkgroupActivity;
}

export const WorkActivityGroupUser = ({ WorkActivityGroup }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityGroupUser);
    const paginador = usePaginator();

    const fileService = new FileService();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar usuario del grupo", MODAL_SM);

    useEffect(() => {
        if (WorkActivityGroup.IDWorkActivityGroup) {
            getLista();
        }
    }, [WorkActivityGroup])

    const getIMGUser = (mediaPhoto: string) => {
        let photo: string = "";
        if (mediaPhoto) {
            photo = fileService.getUrlFile("photos", mediaPhoto);
        } else {
            photo = "./assets/images/core/avatar.png"
        }

        return `
            <img 
                src="${photo}" 
                alt="profile_img"
                style="
                    width:40px;
                    height:40px;
                    object-fit:cover;
                    border-radius:50%;
                "
            />
        `;
    }

    const getLista = () => {
        const props = {
            IDGroup: WorkActivityGroup.IDWorkActivityGroup,
            State: 1,
        }
        instance.getWorkActivityGroupUserRender(paginador.page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)

                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;

                    data.UserEntity = `${data.AccountNit} - ${data.AccountFullName}`;
                    data.IMG = getIMGUser(data.AccountPhoto)

                });

                setLista(resp.List);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivityGroupUser', visible: true },
        { title: 'Foto', property: 'IMG', visible: true, Style: { display: "flex", justifyContent: "center" } },
        { title: 'Empleado', property: 'UserEntity', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
    ];

    const create = () => {
        setBean({
            State: 1,
            IDGroup: WorkActivityGroup.IDWorkActivityGroup
        });
        modal.open("Agregar usuario al grupo")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivityGroupUser(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <AccountEditor idAccount={bean.IDAccount} label="usuario" onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.GroupName}</strong>
                </ModalConfirm>

            </div>
        </div>
    )
}